// Shared header/sidebar resource labels, Font Awesome classes, and colors.
export const RESOURCE_DISPLAY_KEYS = [
  "gold",
  "essence",
  "food",
  "wood",
  "stone",
  "iron",
  "gems",
  "population",
];

export const HEADER_RESOURCE_KEYS = RESOURCE_DISPLAY_KEYS.filter(
  (key) => key !== "population"
);

export const resourceDisplayMap = {
  gold: { name: "Gold", icon: "fas fa-coins", color: "#FFD700" },
  essence: { name: "Essence", icon: "fas fa-bolt", color: "#87CEEB" },
  food: { name: "Food", icon: "fas fa-bread-slice", color: "#F0E68C" },
  wood: { name: "Wood", icon: "fas fa-tree", color: "#8B4513" },
  stone: { name: "Stone", icon: "fas fa-mountain", color: "#A9A9A9" },
  iron: { name: "Iron", icon: "fas fa-cube", color: "#A19D94" },
  gems: { name: "Gem", icon: "fas fa-gem", color: "#00F0FF" },
  population: { name: "Population", icon: "fas fa-users", color: "#F5DEB3" },
};

export function resourceDisplay(key) {
  return (
    resourceDisplayMap[key] || {
      name: key,
      icon: "fas fa-box",
      color: "#ffffff",
    }
  );
}

export function getResourceIcon(key) {
  return resourceDisplay(key).icon;
}

export const STARTING_PLAYER_RESOURCES = {
  gold: 100,
  food: 50,
  wood: 250,
  stone: 150,
  iron: 25,
  essence: 0,
  gems: 0,
};

export const STARTING_CITY_POPULATION = 10;

export function projectResourceStocks(
  base,
  rates,
  lastTickedAt,
  clockOffsetMs,
  intervalMs
) {
  if (!base) return {};
  const projected = { ...base };
  const lastMs = new Date(lastTickedAt).getTime();
  const floorBalances = (stocks) => {
    const next = { ...stocks };
    for (const key of RESOURCE_DISPLAY_KEYS) {
      if (next[key] == null) continue;
      const n = Number(next[key]);
      if (!Number.isFinite(n)) continue;
      next[key] = Math.max(0, n);
    }
    return next;
  };
  if (!Number.isFinite(lastMs)) return floorBalances(projected);

  const serverNow = Date.now() + (Number(clockOffsetMs) || 0);
  const elapsedMs = serverNow - lastMs;
  if (elapsedMs < 0) return floorBalances(projected);

  const interval = Number(intervalMs);
  if (!(interval > 0)) return floorBalances(projected);

  for (const key of RESOURCE_DISPLAY_KEYS) {
    const entry = rates?.[key];
    const rate =
      entry && typeof entry === "object"
        ? Number(entry.net) || 0
        : Number(entry) || 0;
    if (rate === 0) continue;
    projected[key] = (Number(base[key]) || 0) + rate * (elapsedMs / interval);
  }

  return floorBalances(projected);
}
